import { render, staticRenderFns } from "./VersionCheckToast.vue?vue&type=template&id=4b2dfcf9&scoped=true"
import script from "./VersionCheckToast.vue?vue&type=script&lang=js"
export * from "./VersionCheckToast.vue?vue&type=script&lang=js"
import style0 from "./VersionCheckToast.vue?vue&type=style&index=0&id=4b2dfcf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2dfcf9",
  null
  
)

export default component.exports